/**
 * CenteredQRのリロードセクションを表示すべきかどうかを判定する
 * @param {boolean} isCenteredQR - CenteredQR券面かどうか
 * @param {boolean} isLoadingQRInfo - QR情報取得中かどうか
 * @param {boolean|null} isValidQrString - QRコードが有効かどうか（null=取得前）
 * @param {boolean} hasNetworkSpeedIssue - ネットワークエラーが発生しているかどうか
 * @returns {boolean}
 */
export const checkIsCenteredQrReloadSection = ({
  isCenteredQR,
  isLoadingQRInfo,
  isValidQrString,
  hasNetworkSpeedIssue,
}) => {
  return (
    isCenteredQR &&
    !isLoadingQRInfo &&
    (isValidQrString === false || hasNetworkSpeedIssue)
  );
};
